import { render, staticRenderFns } from "./RepSaldoxPeriodo.vue?vue&type=template&id=6d653718&scoped=true&"
import script from "./RepSaldoxPeriodo.vue?vue&type=script&lang=js&"
export * from "./RepSaldoxPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./RepSaldoxPeriodo.vue?vue&type=style&index=0&id=6d653718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d653718",
  null
  
)

export default component.exports